import { preloadImage } from '@utils/common';

async function upgradeImageHotspotsV1Data(data) {
  if (!data.backgroundImage) {
    return {
      version: "v2",
      background: null,
      settings: {
        showMode: "overlay",
        hotspotColor: data.color
      },
      hotspots: []
    };
  }
  const img = await preloadImage(data.backgroundImage);
  const imageDimensions = {
    width: img.naturalWidth,
    height: img.naturalHeight
  };
  return {
    version: "v2",
    settings: {
      hotspotColor: data.color,
      showMode: data.showmode === "text" ? "modal" : "overlay"
    },
    background: {
      src: data.backgroundImage,
      aspectRatio: imageDimensions.width / imageDimensions.height,
      dimensions: {
        naturalWidth: imageDimensions.width,
        naturalHeight: imageDimensions.height
      },
      alt: null,
      longDesc: null
    },
    hotspots: data.hotspots.map(hotspot => {
      if (!imageDimensions) {
        throw new Error("imageHotspotsDataSchema(): Unable to extract background image dimensions");
      }
      const media = (() => {
        if (!hotspot.mediaPath) {
          return {
            selectedMedia: hotspot.mediaType !== "photo-id" ? hotspot.mediaType : "photo"
          };
        }
        switch (hotspot.mediaType) {
          case "photo":
            return {
              selectedMedia: "photo",
              photo: {
                src: hotspot.mediaPath,
                copyright: hotspot.mediaCopyright,
                alt: null,
                longDesc: null
              }
            };
          case "photo-id":
            // NB: photo-id is no longer supported, and as such we reset the
            // media when upgrading to v2.
            return {
              selectedMedia: "photo",
              photo: {
                src: `${process.env["COMPONENT_FRAMEWORK_API"]}/api/Media/Get/${hotspot.mediaPath}`,
                copyright: hotspot.mediaCopyright,
                alt: null,
                longDesc: null
              }
            };
          case "sound":
            return {
              selectedMedia: "sound",
              sound: {
                id: hotspot.mediaPath
              }
            };
          case "video":
            // NB: videos are no longer supported, and as such we reset the
            // media when upgrading to v2.
            return {
              selectedMedia: null
            };
          default:
            return {
              selectedMedia: null
            };
        }
      })();
      return {
        id: hotspot.id,
        title: hotspot.title,
        text: hotspot.text,
        hotspotGraphicsAlt: null,
        hotspotGraphicsURL: null,
        position: {
          x: hotspot.position.x / imageDimensions.width,
          y: hotspot.position.y / imageDimensions.height
        },
        media
      };
    })
  };
}

export { upgradeImageHotspotsV1Data };
//# sourceMappingURL=image-hotspots.component-data.upgrade-v1.js.map
